import script from "./SupportSend.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportSend.vue?vue&type=script&setup=true&lang=js"

import "./SupportSend.vue?vue&type=style&index=0&id=cb3348f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb3348f0"]])

export default __exports__